import {
  loanSchema,
  scheduleSchema,
  type Loan,
  type LoanInput,
  type LoanUpdate,
  type Schedule,
} from '@app/shared';
import { z } from 'zod';
import { apiFetch } from '@/lib/api';

export function fetchLoans(propertyId: number, includeArchived = false): Promise<Loan[]> {
  return apiFetch(`/api/properties/${propertyId}/loans?includeArchived=${includeArchived}`, {
    schema: z.array(loanSchema),
  });
}

export function fetchLoan(propertyId: number, loanId: number): Promise<Loan> {
  return apiFetch(`/api/properties/${propertyId}/loans/${loanId}`, { schema: loanSchema });
}

export function createLoan(propertyId: number, input: LoanInput): Promise<Loan> {
  return apiFetch(`/api/properties/${propertyId}/loans`, { method: 'POST', body: input, schema: loanSchema });
}

export function updateLoan(propertyId: number, loanId: number, input: LoanUpdate): Promise<Loan> {
  return apiFetch(`/api/properties/${propertyId}/loans/${loanId}`, {
    method: 'PATCH',
    body: input,
    schema: loanSchema,
  });
}

export function archiveLoan(propertyId: number, loanId: number, archived: boolean): Promise<Loan> {
  return updateLoan(propertyId, loanId, { archived });
}

export function fetchSchedule(propertyId: number, loanId: number): Promise<Schedule> {
  return apiFetch(`/api/properties/${propertyId}/loans/${loanId}/schedule`, { schema: scheduleSchema });
}

export function generateSchedule(propertyId: number, loanId: number): Promise<Schedule> {
  return apiFetch(`/api/properties/${propertyId}/loans/${loanId}/schedule`, {
    method: 'POST',
    schema: scheduleSchema,
  });
}
